<div class="content-wrapper">
  <div class="header bold">
    {{ 'order.edit.articleInfo' | translate }}
  </div>
  <itl-integratedcare-article [article]="articleLine.article" [hideChevron]="true"></itl-integratedcare-article>
  <div class="header bold">
    {{ 'crossTherapy.document.amountAndUnit' | translate }}
  </div>
  <div class="amount">
    <div class="options">
      <div class="options-amount">
        <div class="options-amount-packaging bold" tappable (click)="openUnitSelect()">
          {{ articleLine?.quantity }} {{ articleLine?.packagingUnit?.unit | articleUnitPipe }} ({{
            articleLine?.packagingUnit?.quantity
          }}
          {{ 'careproposal.create.shoppingCart-listitems.unit' | translate }})
          <ion-icon name="chevron-down-outline"></ion-icon>
        </div>
        <div class="options-amount-change">
          {{ 'careproposal.create.shoppingCart-listitems.amount' | translate }}
          <div class="options-amount-change-deleteAmount" tappable (click)="decreaseQuantity()">
            <ion-icon name="remove"></ion-icon>
          </div>
          <input
            class="options-amount-change-amountInput bold"
            type="number"
            min="0"
            step="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            oninput="validity.valid||(value=0);"
            [(ngModel)]="articleLine.quantity"
          />
          <div class="options-amount-change-addAmount" tappable (click)="increaseQuantity()">
            <ion-icon name="add"></ion-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="header bold" *ngIf="showIdentificationNumbers || showStorageLocation">
      {{ 'order.edit.identificationNumbers' | translate }}
    </div>
    <div
      class="scan"
      *ngIf="showIdentificationNumbers && (articleLine.article.requiresSerialnumber || articleLine.serialNumber)"
    >
      <div class="number-to-scan">
        <itl-text
          [title]="'crossTherapy.document.serialNumber' | translate"
          required="showIdentificationNumbers"
          [(ngModel)]="articleLine.serialNumber"
          (ngModelChange)="tryToParseBarcode($event, 'serialNumber')"
          icon="alberta-scan"
          [placeholder]="'crossTherapy.document.scanSerialNumber' | translate"
        ></itl-text>
        <div *ngIf="scanSerialNumberError" class="error">
          {{ scanSerialNumberError }}
        </div>
      </div>
      <itl-button *ngIf="showScanButtons" (click)="scanSerialNumber()" class="scan-button">
        <ion-icon name="alberta-scan"></ion-icon>{{ 'crossTherapy.document.scan' | translate }}
      </itl-button>
    </div>
    <div
      class="scan"
      *ngIf="showIdentificationNumbers && (articleLine.article.requiresBatchnumber || articleLine.batchNumber)"
    >
      <div class="number-to-scan">
        <itl-text
          [title]="'crossTherapy.document.batchNumber' | translate"
          required="showIdentificationNumbers"
          [(ngModel)]="articleLine.batchNumber"
          (ngModelChange)="tryToParseBarcode($event, 'batchNumber')"
          icon="alberta-scan"
          [placeholder]="'crossTherapy.document.scanBatchNumber' | translate"
        ></itl-text>
        <div *ngIf="scanBatchNumberError" class="error">
          {{ scanBatchNumberError }}
        </div>
      </div>
      <itl-button *ngIf="showScanButtons" (click)="scanBatchNumber()" class="scan-button">
        <ion-icon name="alberta-scan"></ion-icon>{{ 'crossTherapy.document.scan' | translate }}
      </itl-button>
    </div>

    <div class="operating-hours">
      <itl-text
        *ngIf="showIdentificationNumbers && articleLine.article.requiresSerialnumber"
        [maxlength]="operatingHoursLength"
        [title]="'crossTherapy.document.operatingHours' | translate"
        [(ngModel)]="articleLine.operatingHours"
        (ngModelChange)="emitArticleLineChanged()"
        type="number"
        trimEnabled="true"
        required="showIdentificationNumbers"
        min="1"
        icon="alberta-operating-hours"
      ></itl-text>
    </div>

    <itl-text
      *ngIf="showStorageLocation"
      [title]="'crossTherapy.document.storageLocation' | translate"
      icon="alberta-produce"
      [(ngModel)]="articleLine.storageLocation"
    ></itl-text>
    <itl-selection
      *ngIf="showStorageLocation"
      [values]="resmedTenantOptions"
      [(ngModel)]="articleLine.resmedTenant"
      (ngModelChange)="emitArticleLineChanged()"
      [title]="'crossTherapy.document.resmedTenantOptions' | translate"
      noDeleteButton="true"
      required="true"
    ></itl-selection>
  </div>
</div>
